module.exports = __webpack_public_path__ + "static/media/programming-on-imac.9cccd9ad.jpg";